module.exports = __webpack_public_path__ + "img/icn_technology_innovation3.11f84e22.png";